import './imageStyle.scss';

const ImageStyle = ({ imageURL, onClick, sceneLinkId }) => {
  return (
    <div
      className="image-container"
      onClick={onClick}
      style={{ pointerEvents: sceneLinkId ? 'all' : ' none' }}
    >
      <img src={imageURL} alt="MediaImage" />
    </div>
  );
};

export default ImageStyle;
